import type { BatchSelectionPanelProps } from '../types'

import { Button } from 'antd'

export function BatchSelectionPanel({
  colSpan,
  selectedItemsCount,
  pluralization = ['item', 'items'],
  children,
  onClearSelection
}: BatchSelectionPanelProps): JSX.Element | null {
  if (selectedItemsCount === 0) {
    return null
  }

  return (
    <tr>
      <td colSpan={colSpan} className='!bg-[#e9f4fe] !border-b !border-b-gray-200'>
        <div className='w-full py-3 pl-[3.25rem] px-4 flex flex-row justify-start items-baseline gap-2'>
          <span className='font-semibold font-lato text-sm'>
            {selectedItemsCount} {selectedItemsCount === 1 ? pluralization[0] : pluralization[1]}{' '}
            selected
          </span>

          {typeof onClearSelection === 'function' && (
            <Button type='link' onClick={onClearSelection} className='font-lato'>
              Clear selection
            </Button>
          )}

          {children}
        </div>
      </td>
    </tr>
  )
}
